const setMarkets = (market) => {
  if (!market) market = 'sports'

  document.querySelector('.bookie-list--heading')
    .querySelectorAll('button[data-orderby]')
    .forEach(btn => { btn.dataset.market = market })
}

const setArrows = (button, order) => {
  if (!button.classList.contains('order-button')) return

  button.dataset.order = order ? 'asc' : 'desc'
  button.querySelector('span').innerHTML = order ? '&#8675;' : '&#8673;'
}

const setHighlights = (button, orderby) => {
  document.querySelectorAll('button[data-orderby]')
    .forEach(btn => { btn.classList.remove('sortedBy') })

  button.classList.add('sortedBy')

  document.querySelectorAll(`li[data-bookie] .${orderby}`)
    .forEach(item => item.classList.add('highlight'))
}

export { setArrows, setMarkets, setHighlights }
